import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";

import { APButtonLink } from "./APButtonLink";
import APIcon, { APIconName } from "./APIcon";

const APToggleChip = ({
  icon,
  text,
  toggleText,
  color,
  onToggle,
}: {
  icon: APIconName;
  text: string;
  toggleText: string;
  color: "success" | "error";
  onToggle: () => void;
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Chip
        icon={<APIcon name={icon} />}
        label={text}
        color={color}
        sx={{ px: 1 }}
      />
      <APButtonLink text={toggleText} onClick={onToggle} />
    </Box>
  );
};

export default APToggleChip;
